// Fragment "flows (lot K)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    // Signup.jsx — toasts
    "signup.toast.paymentCancelled": "Paiement annulé. Vous pouvez réessayer.",
    "signup.toast.fillRequired": "Veuillez remplir tous les champs requis.",
    "signup.toast.slugTooShort": "Le slug doit faire au moins 2 caractères.",
    "signup.toast.practiceNameTooShort": "Le nom de la pratique doit contenir au moins 2 caractères.",
    "signup.toast.practiceNameTooLong": "Le nom de la pratique ne peut pas dépasser 120 caractères.",
    "signup.toast.acceptTermsRequired": "Veuillez accepter les Conditions d'utilisation et la Politique de confidentialité.",
    "signup.toast.demoCreated": "Compte créé en mode démo ! Redirection...",
    "signup.toast.invalidData": "Données invalides",
    "signup.toast.genericError": "Erreur lors de l'inscription",
    // SignupSummary.jsx
    "signup.summaryTitle": "Récapitulatif",
    "signup.summaryAnnual": "Annuel",
    "signup.summaryAnnualSavings": "2 mois offerts vs mensuel",

    // AuthBridge.jsx — dictionnaire local dissous, verbatim
    "authBridge.title": "Connexion",
    "authBridge.prompt": "Connectez-vous pour revenir sur le site que vous consultiez.",
    "authBridge.redirecting": "Connexion en cours…",
    "authBridge.invalidReturn": "Lien de retour invalide.",
    "authBridge.mintFailed": "Ce site ne peut pas recevoir la connexion.",
    "authBridge.back": "Retour à l'accueil",
    "authBridge.sessionPrompt": "Vous êtes déjà connecté sur Solunary.",
    "authBridge.continueAs": "Continuer en tant que {email}",
    "authBridge.useAnotherAccount": "Utiliser un autre compte",

    // SubscribeSuccess.jsx
    "subscribe.activating": "Activation en cours…",
    "subscribe.checkingPayment": "Nous vérifions votre paiement",
    "subscribe.attemptSuffix": " (essai {n}/8)",
    "subscribe.welcomeTitle": "Bienvenue ! 🎉",
    "subscribe.activatedPrefix": "Votre cabinet",
    "subscribe.activatedSuffix": "est activé.",
    "subscribe.demoModeNote": "(Mode démo — aucun paiement réel)",
    "subscribe.trialStarted": "Ton essai gratuit de {days} jours commence maintenant.",
    "subscribe.completeProfile": "Compléter mon profil",
    "subscribe.viewPublicSite": "Voir mon site public",
    "subscribe.paymentPending": "Paiement en attente",
    "subscribe.pendingHint": "Si le problème persiste, réessayez ou contactez le support.",
    "subscribe.retry": "Réessayer",

    // SolunaryP3.jsx — Care
    "p3.care.subtitle": "Consultations en visioconférence avec praticiens certifiés.",
    "p3.care.empty": "Aucune session pour l'instant.",
    "p3.care.emptyHint": "Les praticiens connectés peuvent créer des sessions vidéo depuis leur dashboard.",
    "p3.care.joinSession": "Rejoindre la session",
    // SolunaryP3.jsx — Learn
    "p3.learn.subtitle": "Programmes vidéo créés par les praticiens.",
    "p3.learn.empty": "Aucun cours pour l'instant.",
    "p3.learn.allCourses": "Tous les cours",
    "p3.learn.enroll": "S'inscrire",
    "p3.learn.courseContent": "Contenu du cours",
    "p3.learn.noModules": "Aucun module défini.",
    // SolunaryP3.jsx — Circle
    "p3.circle.subtitle": "Communauté de praticiens et patients.",
    "p3.circle.emailPlaceholder": "Ton email",
    "p3.circle.titlePlaceholder": "Titre",
    "p3.circle.bodyPlaceholder": "Partage avec la communauté...",
    "p3.circle.submit": "Publier",
    "p3.circle.empty": "Aucun post. Sois le premier !",

    // SolunaryBlog.jsx — chrome (pas les champs de contenu, localisés via useLocalized)
    "blog.pageTitle": "Blog",
    "blog.pageSubtitle": "Histoires, science et vision pour le futur du bien-être.",
    "blog.empty": "Aucun article pour le moment.",
    "blog.allPosts": "Tous les articles",
    "blog.notFound": "Article introuvable",
    "blog.filteredBy": "Filtré par : {tag}",
    "blog.clearFilter": "Effacer le filtre",
    "blog.loadMore": "Voir plus d'articles",
  },
  en: {
    // Signup.jsx — toasts
    "signup.toast.paymentCancelled": "Payment cancelled. You can try again.",
    "signup.toast.fillRequired": "Please fill in all required fields.",
    "signup.toast.slugTooShort": "The slug must be at least 2 characters.",
    "signup.toast.practiceNameTooShort": "A practice name needs at least 2 characters.",
    "signup.toast.practiceNameTooLong": "A practice name cannot exceed 120 characters.",
    "signup.toast.acceptTermsRequired": "Please accept the Terms of Service and Privacy Policy.",
    "signup.toast.demoCreated": "Account created in demo mode! Redirecting...",
    "signup.toast.invalidData": "Invalid data",
    "signup.toast.genericError": "Error during signup",
    // SignupSummary.jsx
    "signup.summaryTitle": "Summary",
    "signup.summaryAnnual": "Annual",
    "signup.summaryAnnualSavings": "2 months free vs monthly",

    // AuthBridge.jsx — dictionnaire local dissous, verbatim
    "authBridge.title": "Sign in",
    "authBridge.prompt": "Sign in to return to the site you were visiting.",
    "authBridge.redirecting": "Signing you in…",
    "authBridge.invalidReturn": "Invalid return link.",
    "authBridge.mintFailed": "This site cannot receive the sign-in.",
    "authBridge.back": "Back to home",
    "authBridge.sessionPrompt": "You are already signed in to Solunary.",
    "authBridge.continueAs": "Continue as {email}",
    "authBridge.useAnotherAccount": "Use another account",

    // SubscribeSuccess.jsx
    "subscribe.activating": "Activating…",
    "subscribe.checkingPayment": "We're verifying your payment",
    "subscribe.attemptSuffix": " (attempt {n}/8)",
    "subscribe.welcomeTitle": "Welcome! 🎉",
    "subscribe.activatedPrefix": "Your practice",
    "subscribe.activatedSuffix": "is now active.",
    "subscribe.demoModeNote": "(Demo mode — no real payment)",
    "subscribe.trialStarted": "Your {days}-day free trial starts now.",
    "subscribe.completeProfile": "Complete my profile",
    "subscribe.viewPublicSite": "View my public site",
    "subscribe.paymentPending": "Payment pending",
    "subscribe.pendingHint": "If the issue persists, try again or contact support.",
    "subscribe.retry": "Try again",

    // SolunaryP3.jsx — Care
    "p3.care.subtitle": "Video consultations with certified practitioners.",
    "p3.care.empty": "No sessions yet.",
    "p3.care.emptyHint": "Connected practitioners can create video sessions from their dashboard.",
    "p3.care.joinSession": "Join the session",
    // SolunaryP3.jsx — Learn
    "p3.learn.subtitle": "Video programs created by practitioners.",
    "p3.learn.empty": "No courses yet.",
    "p3.learn.allCourses": "All courses",
    "p3.learn.enroll": "Enroll",
    "p3.learn.courseContent": "Course content",
    "p3.learn.noModules": "No modules defined.",
    // SolunaryP3.jsx — Circle
    "p3.circle.subtitle": "Community of practitioners and patients.",
    "p3.circle.emailPlaceholder": "Your email",
    "p3.circle.titlePlaceholder": "Title",
    "p3.circle.bodyPlaceholder": "Share with the community...",
    "p3.circle.submit": "Post",
    "p3.circle.empty": "No posts yet. Be the first!",

    // SolunaryBlog.jsx — chrome (pas les champs de contenu, localisés via useLocalized)
    "blog.pageTitle": "Blog",
    "blog.pageSubtitle": "Stories, science and vision for the future of wellness.",
    "blog.empty": "No articles yet.",
    "blog.allPosts": "All articles",
    "blog.notFound": "Article not found",
    "blog.filteredBy": "Filtered by: {tag}",
    "blog.clearFilter": "Clear filter",
    "blog.loadMore": "Load more articles",
  },
  es: {
    // Signup.jsx — toasts
    "signup.toast.paymentCancelled": "Pago cancelado. Puedes volver a intentarlo.",
    "signup.toast.fillRequired": "Por favor completa todos los campos obligatorios.",
    "signup.toast.slugTooShort": "El slug debe tener al menos 2 caracteres.",
    "signup.toast.practiceNameTooShort": "El nombre de la práctica necesita al menos 2 caracteres.",
    "signup.toast.practiceNameTooLong": "El nombre de la práctica no puede superar los 120 caracteres.",
    "signup.toast.acceptTermsRequired": "Por favor acepta las Condiciones de uso y la Política de privacidad.",
    "signup.toast.demoCreated": "¡Cuenta creada en modo demo! Redirigiendo...",
    "signup.toast.invalidData": "Datos inválidos",
    "signup.toast.genericError": "Error durante el registro",
    // SignupSummary.jsx
    "signup.summaryTitle": "Resumen",
    "signup.summaryAnnual": "Anual",
    "signup.summaryAnnualSavings": "2 meses gratis vs mensual",

    // AuthBridge.jsx — dictionnaire local dissous, verbatim
    "authBridge.title": "Iniciar sesión",
    "authBridge.prompt": "Inicia sesión para volver al sitio que estabas visitando.",
    "authBridge.redirecting": "Conectando…",
    "authBridge.invalidReturn": "Enlace de retorno no válido.",
    "authBridge.mintFailed": "Este sitio no puede recibir la conexión.",
    "authBridge.back": "Volver al inicio",
    "authBridge.sessionPrompt": "Ya has iniciado sesión en Solunary.",
    "authBridge.continueAs": "Continuar como {email}",
    "authBridge.useAnotherAccount": "Usar otra cuenta",

    // SubscribeSuccess.jsx
    "subscribe.activating": "Activando…",
    "subscribe.checkingPayment": "Estamos verificando tu pago",
    "subscribe.attemptSuffix": " (intento {n}/8)",
    "subscribe.welcomeTitle": "¡Bienvenido! 🎉",
    "subscribe.activatedPrefix": "Tu consultorio",
    "subscribe.activatedSuffix": "está activo.",
    "subscribe.demoModeNote": "(Modo demo — sin pago real)",
    "subscribe.trialStarted": "Tu prueba gratuita de {days} días comienza ahora.",
    "subscribe.completeProfile": "Completar mi perfil",
    "subscribe.viewPublicSite": "Ver mi sitio público",
    "subscribe.paymentPending": "Pago pendiente",
    "subscribe.pendingHint": "Si el problema persiste, vuelve a intentarlo o contacta con soporte.",
    "subscribe.retry": "Reintentar",

    // SolunaryP3.jsx — Care
    "p3.care.subtitle": "Consultas por videollamada con profesionales certificados.",
    "p3.care.empty": "Aún no hay sesiones.",
    "p3.care.emptyHint": "Los profesionales conectados pueden crear sesiones de video desde su panel.",
    "p3.care.joinSession": "Unirse a la sesión",
    // SolunaryP3.jsx — Learn
    "p3.learn.subtitle": "Programas en video creados por profesionales.",
    "p3.learn.empty": "Aún no hay cursos.",
    "p3.learn.allCourses": "Todos los cursos",
    "p3.learn.enroll": "Inscribirme",
    "p3.learn.courseContent": "Contenido del curso",
    "p3.learn.noModules": "Ningún módulo definido.",
    // SolunaryP3.jsx — Circle
    "p3.circle.subtitle": "Comunidad de profesionales y pacientes.",
    "p3.circle.emailPlaceholder": "Tu correo",
    "p3.circle.titlePlaceholder": "Título",
    "p3.circle.bodyPlaceholder": "Comparte con la comunidad...",
    "p3.circle.submit": "Publicar",
    "p3.circle.empty": "Aún no hay publicaciones. ¡Sé el primero!",

    // SolunaryBlog.jsx — chrome (pas les champs de contenu, localisés via useLocalized)
    "blog.pageTitle": "Blog",
    "blog.pageSubtitle": "Historias, ciencia y visión para el futuro del bienestar.",
    "blog.empty": "Aún no hay artículos.",
    "blog.allPosts": "Todos los artículos",
    "blog.notFound": "Artículo no encontrado",
    "blog.filteredBy": "Filtrado por: {tag}",
    "blog.clearFilter": "Quitar filtro",
    "blog.loadMore": "Ver más artículos",
  },
};
